import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {projectColors} from '../../utils';
import {HexColorInput} from '../inputs';
import {CheckmarkIcon} from '../../icons/checkmark-icon';

const ColorPickerWrapper = Styled.div`
    display:flex;
    flex-direction:column;
    border:1px solid #e6e6e6;
    border-radius: 4px;
`;

const ProjectColorsSection = Styled.div`
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    padding: 16px;
`;

export const ColorsWrapper = Styled.div`
	display:flex;
	flex-direction:row;
	justify-content: space-around;
	flex: 1;
`;

const ColorWrapper = Styled.div`
	position: relative;
 `;

const SelectionBox = Styled.div`
	position: absolute;
	top: -4px;
	right: -4px;
	width: 31px;
	height: 31px;
	border: 2px solid ${props => (props.isSelected ? props.color : 'transparent')};
	box-sizing: border-box;
	filter: blur(1px);
	border-radius: 6px;

`;

const ColorBox = Styled.div`
    height:23px;
    width:23px;
    border-radius:3px;
	background-color:${props => props.color};
	display:flex;
	justify-content:center;
`;

const HexPicker = Styled.div`
	margin: 16px 0 0 0;
	padding: 16px 0 0 0;
	width:100%;
	border-top: solid 1px #e6e6e6;

	display:flex;
	flex-direction:row;
	align-items:center;
`;

const CustomHexText = Styled.div`
	width:167px;
	font-size: 13px;
`;

export const HexColorInputWrapper = Styled.div`
	width:176px;
	margin-right:19px;
`;

export const ColorPicker = ({chooseColor, selectedColor, showHexPicker}) => {
	const [_erroCustomHexColor, setErroCustomHexColor] = useState(false);
	const [_customHexColor, setCustomHexColor] = useState(projectColors.includes(selectedColor) ? '' : selectedColor);

	const onSelectColor = color => {
		chooseColor(color);
		if (_erroCustomHexColor) {
			setCustomHexColor('');
		}
		setErroCustomHexColor(false);
	};

	const onSelectCustomColor = color => {
		let formatedHex = color ? color.replace('#', '') : '';
		if (formatedHex.length === 6 && !isNaN(Number('0x' + formatedHex))) {
			chooseColor(color);
			setCustomHexColor(color || '');
			setErroCustomHexColor(false);
		} else {
			setErroCustomHexColor(true);
		}
	};

	return (
		<ColorPickerWrapper>
			<ProjectColorsSection>
				<ColorsWrapper>
					{projectColors.map((color, idx) => {
						const isSelected = selectedColor === color;
						return (
							<ColorWrapper key={idx} onClick={() => onSelectColor(color)}>
								<SelectionBox color={color} isSelected={selectedColor === color}></SelectionBox>
								<ColorBox color={color} isSelected={isSelected}>
									{isSelected && <CheckmarkIcon color={'white'}></CheckmarkIcon>}
								</ColorBox>
							</ColorWrapper>
						);
					})}
				</ColorsWrapper>
				{showHexPicker && (
					<HexPicker>
						<CustomHexText>Custom HEX</CustomHexText>
						<HexColorInputWrapper>
							<HexColorInput
								value={_customHexColor}
								placeholder={projectColors[0]}
								callback={onSelectCustomColor}
								alignLeft={true}
							/>
						</HexColorInputWrapper>
						<ColorWrapper>
							<SelectionBox
								color={_customHexColor}
								isSelected={selectedColor === _customHexColor && !_erroCustomHexColor}
							></SelectionBox>
							<ColorBox
								color={(!_erroCustomHexColor && _customHexColor) || projectColors[0]}
								isSelected={selectedColor === _customHexColor && !_erroCustomHexColor}
							>
								{selectedColor === _customHexColor && !_erroCustomHexColor && (
									<CheckmarkIcon color={'white'}></CheckmarkIcon>
								)}
							</ColorBox>
						</ColorWrapper>
					</HexPicker>
				)}
			</ProjectColorsSection>
		</ColorPickerWrapper>
	);
};

ColorPicker.propTypes = {
	chooseColor: PropTypes.func,
	selectedColor: PropTypes.string,
	showHexPicker: PropTypes.bool,
};
ColorPicker.defaultProps = {
	chooseColor: color => console.log(color),
	showHexPicker: false,
};
